import { render, staticRenderFns } from "./history_button.vue?vue&type=template&id=2cda1529&scoped=true"
import script from "./history_button.vue?vue&type=script&lang=js"
export * from "./history_button.vue?vue&type=script&lang=js"
import style0 from "./history_button.vue?vue&type=style&index=0&id=2cda1529&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cda1529",
  null
  
)

export default component.exports